import React, { useEffect, useRef, useState } from "react";
import DOMPurify from 'dompurify';
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import apiClient from '../../../../services/apiClient';
import "./custom.css";
import UnitOption from "./UnitOption";
import CommonDropdownMenuThree from "../../../Shared/CommonDropdownMenuThree";
import CommonDropdownMenufour from "../../../Shared/CommonDropdownMenufour";
import Swal from "sweetalert2";


function ViewProposalInfoModal({type,id,code}) {

  const [pagescontent, setPagescontent] = useState([]);
    const [showsign, setshowsign] = useState(true);

      const [companylogo, setCompanylogo] = useState();
    
      const [phone, setPhone] = useState();
      const [companyemail, setCompanyemail] = useState();
        const [fname, setFname] = useState();
        const [lname, setLname] = useState();
         const [companyname, setcompanyname] = useState();
         const [customername, setcustomername] = useState('');
      const [invoicecode, setinvoicecode] = useState(0); 
      const [purchageorder, setpurchageorder] = useState('');

       const [smartdate, setsmartdate] = useState(false);
        const [smartday, setsmartday] = useState("");
        const [smartmonth, setsmartmonth] = useState(false);
        const [smartyear, setsmartyear] = useState(false);
          const [proposalstabs, setProposalstabs] = useState([]);
          const [customeremail, setcustomeremail] = useState('');


           const [username, setusername] = useState('');
           const [useremail, setuseremail] = useState('');
            const [usersignature, setUsersignature] = useState('');
            const [customersignature, setcustomersignature] = useState('');
            const [signaturebox, setsignaturebox] = useState("");
            const [isChecked, setIsChecked] = useState(false);

        const options = ["Custom Date", 'Smart date'];
  const options_sub = ["Payment is due on a fixed calendar date", 'Payment due date is based on event or invoice date'];
  const options2 = ["day(s)", "Week(s)", "month(s)"];
  const options3 = ["before event date", "after event date"];

       const currentDate = new Date();
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

      const formattedDate = `${months[currentDate.getMonth()]
    } ${currentDate.getDate()}, ${currentDate.getFullYear()}`;

    const [subtotalprice, setsubtotalprice] = useState(0);
    const [showTaxBox, setShowTaxBox] = useState(false);
    const [taxval, settaxval] = useState(0);
    const [discountval, setdiscountval] = useState(0);
     const [showDiscountBox, setShowDiscountBox] = useState(false);
      const [totalprice, settotalprice] = useState(0);

      const [showDueDateBox, setShowDueDateBox] = useState(null);

         const handleChange = (event) => {
    setsignaturebox(event.target.value);
  };
  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const addsignature = async () => {

  const formData = new FormData();
  formData.append('sharedid', id);
  formData.append('signature', signaturebox);

try {
      /* const response = await apiClient.post(`/setcustomersign', 
                     {sharedid: contractid,
                     });  */

      const response = await apiClient.post(`/setusersignproposal`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.data.success) {
        // alert('Email send Sucessfully');
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Action complete Sucessfully!",
        });
        // navigate("/events");
      }

      setUsersignature(signaturebox);
    } catch (error) {
      console.error("Error fetching contracts:", error);
    }

  }

     
       
        
  
    useEffect(() => {

      
       
      const fetchproposal = async () => {
        try {
          const response = await apiClient.get(`/showsharedproposal/${id}/${code}`);
            const pages = JSON.parse(response.data.sharedproposal.content);
            setCompanylogo(response.data.user.Main_Logo ? process.env.REACT_APP_BACKEND_URL + response.data.user.Main_Logo : null);

          setPhone(response.data.user.Phone_Number);
          setCompanyemail(response.data.user.Company_Email);
          setFname(response.data.user.first_name);
          setLname(response.data.user.last_name);
          setinvoicecode(response.data.sharedproposal.invoicecode);

          setusername(response.data.sharedproposal.username);
          setcustomername(response.data.sharedproposal.customer_name);
          if(response.data.sharedproposal.signed!=null){
          setcustomersignature(response.data.sharedproposal.signed);
          }
          if(response.data.sharedproposal.usersignature!=null){
          setUsersignature(response.data.sharedproposal.usersignature);
          }


          // dispatch(setTitle(response.data.sharedproposal.title));
           setProposalstabs(JSON.parse(response.data.sharedproposal.content));
     // setProposalpages(JSON.parse(response.data.sharedproposal.pages));


            pages.forEach(element => {
            if (element.type == 'contract') {
             // setcontractpresent(true);
              element.pages.forEach(contractelement => {
                let contentnew = { type: 'contract', content: contractelement.content };
                setPagescontent(prevContent => [...prevContent, contentnew]);

              });
            } else if (element.type == 'invoice') {
              let contentnew = { type: 'invoice', content: element };
              setPagescontent(prevContent => [...prevContent, contentnew]);
              //let paymenttab = { type: 'payment', content: 0 };
             // setPagescontent(prevContent => [...prevContent, paymenttab]);
            } else if (element.type == 'questionnaires') {
              let contentnew = { type: 'questionnaires', content: element.questionss };
              setPagescontent(prevContent => [...prevContent, contentnew]);
            }
          });




  
        } catch (error) {
          console.error('Error fetching contract:', error);
        }
      };
      fetchproposal();
  
    }, []); // This runs once when the component mounts

    useEffect(() => {
    
    
    
        var totalprice = 0;
        proposalstabs.map((ptab) => {
    
         
    
    
    
    
    
    
          if (ptab.type == 'invoice') {
    
            //setinvoicepayments(ptab.invoice_payment);
            ptab.invoice_item.map((tab1) => {
              totalprice = parseFloat(totalprice) + parseFloat(tab1.price);
            });
    
            setsubtotalprice(totalprice);
            if (parseInt(ptab.taxper) > 0) {
              totalprice = parseFloat(totalprice) + parseFloat(ptab.taxper * totalprice / 100);
              settaxval(parseFloat(ptab.taxper) * totalprice / 100);
            } else {
              totalprice = parseFloat(totalprice) + parseFloat(ptab.tax);
              settaxval(ptab.tax);
            }
            if (parseInt(ptab.discountper)) {
              totalprice = totalprice - parseInt(ptab.discountper * totalprice / 100);
              setdiscountval(ptab.discountper * totalprice / 100);
            } else {
              totalprice = totalprice - parseInt(ptab.discount);
              setdiscountval(ptab.discount);
            }
            settotalprice(totalprice);
    
          }
        });
    
    
    
        if (proposalstabs.length > 0) {
    
          const proposaltablenght = proposalstabs.length - 1;
    
          var buttonid = '';
    
          if (proposalstabs[proposaltablenght].type == 'contract') {
            buttonid = `ctab0${proposaltablenght}`;
          } else if (proposalstabs[proposaltablenght].type == 'invoice') {
            buttonid = `invoicetab${proposaltablenght}${proposaltablenght}`;
          } else if (proposalstabs[proposaltablenght].type == 'questionnaires') {
            buttonid = `qutab${proposaltablenght}`;
          }
    
    
    
          const activebutton = document.getElementById(buttonid);
          if (activebutton) {
            activebutton.click();
          }
    
        }
    
    
    
        //active.setAttribute("data-scroll", <your_value>)
      }, [proposalstabs]);

  return (
    <div
      className='modal fade'
      id={`exampleModal${id}${code}`}
      tabIndex='-1'
      aria-labelledby='exampleModalLabel'
      aria-hidden='true'
       style={{ background:'#fffff'}}
    >
      <div
        className='modal-dialog modal-lg modal-dialog-centered'
        role='document'
        style={{ minHeight: "700px" }}
      >
        <div className='modal-content'>
          {/* Modal header */}
          <div className='modal-header bg-primary'>
            <h5 className='modal-title text-white w-100 text-center' style={{ textTransform:'uppercase'}}>
              {type}
            </h5>
            <button type='button' className='close' data-bs-dismiss='modal'>
              <span aria-hidden='true' className='modal_button'>
                <i className='fas fa-close'></i>
              </span>
              <span className='sr-only'>Close</span>
            </button>
          </div>
          <div className='modal-body py-5 px-4' style={{ background: "#ffffff" }} >
            <div className='row'>


               {/* <div className='customer_details' style={{ textAlign: "left" }}>
                        Customer info */}
                        {companylogo ? (
                          <>
                         {/*   <div className='logo'>
                              <h4>
                                <img src={companylogo} alt='Main Logo Preview' className='mainimgpath img-fluid' />
                              </h4>
                            </div>*/}
                          </>
                        ) : (<>

                        </>)}
                       {/*  <div className='title'>
                          <h4>{companyname}</h4>
                        </div>
                        <div className='item'>
                          <span style={{ textTransform: "capitalize" }}>{fname} {lname} </span>
                          <span>{phone}</span>
                          <span>{companyemail}</span>

                        </div>
                      </div> */}

              {pagescontent.map((item, index) => (
                <>
                 {item.type == 'contract' && (<>
                 <div className="row left">
                  <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.content) }} />


                 </div>

                 </>)}



             </> ))}

                

       {/* signature part start   */}

          {showsign && (<>

                <div className={"tab-pane"} id='sign' role="tabpanel" aria-labelledby={`sign-tab`} style={{ background: 'white', height: '100%' }} >

                  <div className="position-relative overflow-hidden">

                    <div className="signat">

                      <div className="gap"> &nbsp; </div>
                      <div className="gap"> &nbsp; </div>
                      <div className="gap"> &nbsp; </div>

                      




                      {usersignature !='' && (<>
                        <div className="signaturemain left w-100">
                          {usersignature}
                        </div>
                      </>)}

                       {usersignature =='' && (<>
                        <div className="addbutton">
                          <button

                            className={`nav-link add_Signature`}
                            type='button'
                            data-bs-toggle='offcanvas'
                            data-bs-target='#signpopup'
                            aria-controls='offcanvasRight'
                          >Add Signature </button>

                        </div>
                      </>)}



                      <div className="sign_text">{username}  </div>
                      <div className="sign_text">{useremail}</div>

                      <div className="gap"> <hr /> </div>

                     

                      {customersignature != "" && (<>
                        <div className="signaturemain left w-100">
                          {customersignature}
                        </div>
                      </>)}

                      <div className="sign_text">{customername} </div>
                      <div className="sign_text">{customeremail}</div>


                    </div>

                  </div>

                </div>
              </>)}


              {/* signature part end  */}

               


             {pagescontent.map((item, index) => (
                <>



                {item.type == 'questionnaires' && (<>

                 <div className="position-relative overflow-hidden">
                      <div className="form_container tab-content textContract">


                        {item.content.map((tabques, ind) => (<>



                          {/* start of   questionnaires */}


                          {tabques.type == 'shorttext' && (
                            <div className='col-md-12 d-flex center' key={ind}>

                              <div className='col-md-12 left' style={{ padding: '15px 20px' }}>
                                <label htmlFor='name' className='form-label mt-0'>
                                  {tabques.ques}
                                </label>

                                <div>&nbsp;</div>

                                <label htmlFor='name' className='form-label mt-0'>
                                  {tabques.placeholder}
                                </label>
                              </div>
                            </div>

                          )}


                          {tabques.type == 'FullwidthText' && (
                            <div className='col-md-12 left ' style={{ padding: '15px 20px' }}>
                              <div className='col-md-12 center'>&nbsp;</div>
                              <div className='col-md-12 '>

                                <label htmlFor='name' className='form-label mt-0'>
                                  {tabques.placeholder}
                                </label>

                              </div>
                              <div className='col-md-12 center'>&nbsp;</div>
                            </div>

                          )}


                          {tabques.type == '2ColumnText' && (
                            <div className='col-md-12 d-flex left' style={{ padding: '15px 20px' }}>
                              <div className='col-md-6 margin '>

                                <label htmlFor='name' className='form-label mt-0'>
                                  {tabques.placeholder}
                                </label>
                              </div>
                              <div className='col-md-6 margin'>
                                <div>&nbsp;</div>
                                <label htmlFor='name' className='form-label mt-0'>
                                  {tabques.placeholder}
                                </label>




                              </div>
                            </div>

                          )}


                          {tabques.type == 'twofields' && (
                            <div className='col-md-12 d-flex left' style={{ padding: '15px 20px' }}>
                              <div className='col-md-6 margin left '>
                                <label htmlFor='name' className='form-label mt-0'>
                                  {tabques.ques}
                                </label>
                                <div>&nbsp;</div>
                                <label htmlFor='name' className='form-label mt-0'>
                                 {tabques.placeholder}
                                </label>

                                
                              </div>
                              <div className='col-md-6 margin left'>

                                <label htmlFor='name' className='form-label mt-0'>
                                  {tabques.ques2}
                                </label>
                                <div>&nbsp;</div>
                                <label htmlFor='name' className='form-label mt-0'>
                                  {tabques.placeholder2}
                                </label>


                              

                              </div>
                            </div>

                          )}

                          {tabques.type == 'longtext' && (
                            <div className='col-md-12 d-flex left' style={{ padding: '15px 20px' }}>
                              <div className='col-md-12 left'>
                                <label htmlFor='name' className='form-label mt-0'>
                                  {tabques.ques}
                                </label>
                                <div>&nbsp;</div>
                                <label htmlFor='name' className='form-label mt-0'>
                                  {tabques.placeholder}
                                </label>
                                {/*<textarea placeholder= rows={1} cols="50" name='' id='' className="textare1"  />*/}
                              </div>

                            </div>

                          )}


                          {tabques.type == 'Dropdown' && (
                            <> {tabques.optionadd == 0 ? (<div className='col-md-12 left' style={{ padding: '15px 20px' }}> <div className='col-md-12 left'>

                              <label htmlFor='name' className='form-label mt-0'>
                                {tabques.ques}
                              </label>

                              <select className="selectfull" >
                                {tabques.option.map((optiontab, index2) => (
                                  <option key={index2} selected={tabques.placeholder === optiontab.listpotion} >{optiontab.listpotion} </option>
                                ))}
                              </select>

                            </div></div>) : ('')}
                            </>

                          )}


                          {tabques.type == 'Singlechoice' && (
                            <><div className='col-md-12 mb-10 left' style={{ padding: '15px 20px' }} >

                              <label htmlFor='name' className='form-label mt-0'>
                                {tabques.ques}
                              </label>
                              {tabques.option.map((optiontab, index2) => (
                                <div className='col-md-12 gapbetween' key={index2}>
                                  <div className='col-md-10'>
                                    <input type="radio" id={optiontab.listpotion}  name="fav_language" defaultValue={optiontab.listpotion} 
                                     checked={tabques.placeholder?.includes(optiontab.listpotion)}
                                    />
                                    <label htmlFor={optiontab.listpotion} >{optiontab.listpotion} </label><br />


                                  </div>

                                </div>
                              ))}

                            </div>
                            </>
                          )}


                          {tabques.type == 'Multichoice' && (
                            <> <div className='col-md-12 mb-10 left' style={{ padding: '15px 20px' }} >

                              <label htmlFor='name' className='form-label mt-0'>
                                {tabques.ques}
                              </label>
                              {tabques.option.map((optiontab, index2) => (
                                <div className='col-md-12' key={index2} >

                       <input type="checkbox" id={index2} name="fav_language" defaultValue={optiontab.listpotion} checked={tabques.placeholder2?.includes(optiontab.listpotion)}  />
                                  <label htmlFor={index2} >{optiontab.listpotion} </label><br />



                                </div>
                              ))}


                            </div>
                            </>
                          )}

                          {tabques?.type == 'DatePicker' && (
                            <div className='col-md-12 d-flex left' style={{ padding: '15px 20px' }}>
                              <div className='col-md-12'>
                                <label htmlFor='name' className='form-label mt-0'>
                                  {tabques.ques}
                                </label>
                                <input type="date" className="datetype" value={tabques.placeholder || ""} />
                              </div>
                            </div>

                          )}



                          {/* end of   questionnaires */}





                        </>))}

                      </div>
                    </div>
                
                
                </>)}


                




             {item.type == 'invoice' && (<>

                      
                    <section className='section_container'>
                      {/* Customer Details here */}
                      <div className='customer_details' style={{ textAlign: "left" }}>
                        {/* Customer info */}
                        {companylogo ? (
                          <>
                           {/*  <div className='logo'>
                              <h4>
                                <img src={companylogo} alt='Main Logo Preview' className='mainimgpath img-fluid' />
                              </h4>
                            </div> */}
                          </>
                        ) : (<>

                        </>)}
                         {/* <div className='title'>
                          <h4>{companyname}</h4>
                        </div>
                        <div className='item'>
                          <span style={{ textTransform: "capitalize" }}>{fname} {lname} </span>
                          <span>{phone}</span>
                          <span>{companyemail}</span>

                        </div> */}
                      </div>

                      {/* Invoice content */}
                      <div className='invoice' style={{ textAlign: "left" }}>
                        <h3 style={{ margin: "0px 40px" }}>Invoice</h3>

                        {/* invoice table */}
                        <div className='invoice-table d-flex align-items-center flex-wrap justify-content-between mt-4'>
                          <div
                            className='table_item  invoice_td position-relative'
                            type='button' style={{ textAlign: 'left', paddingLeft: "50px" }}>
                            <span className="hover_effect">Bill to</span><br />

                            <span >{customername}</span>


                          </div>
                          <div
                            className='table_item  invoice_td position-relative'
                            type='button' style={{ marginRight: '6%', textAlign: 'left' }}>
                            <span className="hover_effect">invoice #</span><br />
                            <span>{invoicecode}</span>


                          </div>

                          <div className='table_item  purchase_td position-relative' style={{ marginRight: '1%', textAlign: 'left' }}>
                            <span className="hover_effect">Purchase order #</span><br />
                            <span>{purchageorder}</span>

                          </div>
                        </div>

                        <div className='invoice-table d-flex align-items-center flex-wrap justify-content-between mt-4'>
                          <div></div>
                          <div className='table_item table_item_date_issued position-relative'>
                            <span>&nbsp;Date Issued</span> <br />
                            <div
                              className='date position-absolute'
                              style={{ fontSize: "14px" }}>
                              &nbsp;{formattedDate}
                            </div>
                          </div>
                          <div className='table_item position-relative'>
                            <span>Next Payment Due</span>
                            <br />
                            <div
                              className='date position-absolute'
                              style={{ fontSize: "14px" }}>
                              {item.content.invoice_payment[0].dueDate}
                            </div>
                          </div>
                        </div>

                        {/* service area */}
                        <div className='service_area d-flex align-items-center justify-content-between py-3'>
                          <div className='service_item'>
                            <div className='service_info_top'>
                              <span>SERVICE INFO</span>
                            </div>
                          </div>
                          <div className='service_item d-flex align-items-center'>
                            <span className='me-5'>QTY</span>
                            <span>UNIT</span>
                          </div>
                          <div className='service_item'>
                            <span className='me-3'> { /*TAX*/}&nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;&nbsp; </span>
                            <span>PRICE</span>
                          </div>
                        </div>

                        {/* create new service */}
                        {/* Render dynamic services */}


                        {item.content.invoice_item.map((service, index) => (
                          <div
                            key={index}
                            className='create_new_service flex-wrap d-flex align-items-center justify-content-between py-3 position-relative'>
                            <div className='service_item position-relative'>
                              <div className='service_info_box' style={{ marginTop: "41px" }}>
                                <div
                                  className='service_info'>

                                  <input type='text' id={`name-${index}`} placeholder='Type or Select a Service' value={service.type} disabled style={{ background: 'none' }} />
                                  <small></small>
                                </div>
                                <div className='desc mt-2'> &nbsp;
                                  {/* <textarea name="" className="textare" placeholder='Enter a description' value={service.descp}  onChange={(e) => changedesc(e,index)}></textarea> */}
                                  {/* <input type='text' placeholder='Enter a description' value={service.descp}  onChange={(e) => changedesc(e,index)} /> */}
                                </div>
                              </div>


                              {/* Select item */}

                            </div>
                            <div className='service_item d-flex align-items-center'>
                              {/* QYT field */}
                              <span className='me-2 qyt'>
                                {service.qty}

                              </span>

                              {/* UNIT Field */}
                              <span className='position-relative'>

                                <UnitOption indexval={index} rawselectedOption={service.unit_option} />
                              </span>
                            </div>
                            <div className='service_item d-flex align-items-center'>
                              <div className='form-check '>
                                { /* <input
                              className='form-check-input'
                              type='checkbox'
                              name='tax'
                              value=''
                              id='flexCheckDefault'
                              checked={service.tax ? 'checked' : ''}
                            /> */}
                              </div>
                              <div className='form-check qyt'>
                                {service.price}

                                <small></small>

                              </div>
                            </div>

                            {/* Delete button */}


                            <div className="textare2 left">

                               <p style={{ borderBottom:'1px solid #ccc'}}> {service.descp} </p>


                           {/*
                      
                              <textarea  placeholder='Enter a description' rows={1}  name={index} id={`desc-${index}`} className="textare" value={service.descp}
                                disabled style={{ borderBottom: 'none !important' }} />  */}
                              <small></small>
                            </div>

                          </div>
                        ))}

                        {/* add new item button  */}


                        {/* Summary*/}
                        <div className='card-body'>
                          <div className='row flex-column-reverse flex-md-row row-gap-4 row-gap-md-0'>
                            <div className='col-md-5 d-flex align-items-end'></div>

                            <div className='col-md-7 ml-auto'>
                              <table className='table create_invoice_table table-clear'>
                                <tbody>
                                  <tr>
                                    <td className='left'>
                                      <span>Subtotal</span>
                                    </td>
                                    <td className='right'>${subtotalprice}</td>
                                  </tr>
                                  {/* Tax box */}
                                  <tr>
                                    <td className='left position-relative'>
                                      <span className='pointer' >
                                        Tax {/* <span>8.5%</span> */}
                                      </span>
                                      {showTaxBox && (
                                        <div className='edit_discount_box edit_tax_box position-relative'>
                                          <div className='box_header d-flex align-items-center justify-content-between mb-2'>
                                            <h5>Edit Tax</h5>
                                            <span >
                                              <i className='fas fa-close'></i>
                                            </span>
                                          </div>
                                          <div className='box-content mt-2 d-flex align-items-center'>
                                            <input
                                              type='number'
                                              className='me-2'
                                              placeholder='Tax'
                                              defaultValue=''

                                            />


                                            <div className='input-group'>
                                              <span className={`input-group-text `}

                                                id='basic-addon1' >
                                                %
                                              </span>
                                              <span className={`input-group-text `}

                                                id='basic-addon1' >
                                                $
                                              </span>
                                            </div>

                                            {/* delete button */}
                                            <div>
                                              {" "}
                                              <i className='fas fa-trash text-danger' ></i>
                                            </div>
                                          </div>

                                          <div className='discount_arrow'></div>
                                        </div>
                                      )}
                                    </td>
                                    <td className='right'>${taxval}</td>
                                  </tr>

                                  {/* add discount box */}
                                  <tr>
                                    <td className='left position-relative'>
                                      {showDiscountBox ? (
                                        <span className='pointer'>Discount</span>
                                      ) : (
                                        <span className='pointer' >
                                          + Add Discount
                                        </span>
                                      )}

                                      {/* edit discount box */}
                                      {showDiscountBox && (
                                        <div className='edit_discount_box position-relative'>
                                          <div className='box_header d-flex align-items-center justify-content-between mb-2'>
                                            <h5>Edit Discount</h5>
                                            <span >
                                              <i className='fas fa-close'></i>
                                            </span>
                                          </div>
                                          <div className='box-content mt-2 d-flex align-items-center'>
                                            <input type='number' className='me-2' defaultValue='' />

                                            <div className='input-group'>
                                              <span className={`input-group-text `}

                                                id='basic-addon1'  >
                                                %
                                              </span>
                                              <span className={`input-group-text `}
                                                id='basic-addon1' >
                                                $
                                              </span>
                                            </div>

                                            {/* delete button */}
                                            <div>
                                              {" "}
                                              <i className='fas fa-trash text-danger'  ></i>
                                            </div>
                                          </div>

                                          <div className='discount_arrow'></div>
                                        </div>
                                      )}
                                    </td>
                                    <td className='right'>
                                      <strong>${discountval}</strong>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className='left'>
                                      <span>Total USD</span>
                                    </td>
                                    <td className='right'>
                                      <strong> {totalprice} </strong>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>

                    <section className='section_container my-4 px-2 px-md-5 py-5'>
                                          <div className='title'>
                                            <h4>PAYMENT SCHEDULE</h4>
                                          </div>
                    
                                          <div className='payment_schedule_container mt-2'>
                                            <table>
                                              <thead>
                                                <tr>
                                                  <th scope='col' style={{ width: "74px" }}>
                                                    AMOUNT
                                                  </th>
                                                  <th scope='col'>DUE DATE</th>
                                                  <th scope='col'>PAYMENT DATE</th>
                                                  <th scope='col'>PAYMENT ID</th>
                                                  <th scope='col' style={{ width: "74px" }}>
                                                    STATUS
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                    
                                                {item.content.invoice_payment.map((data, i) => (
                                                  <tr key={i}>
                                                    <td data-label='Amount'>
                                                      <span className='hover_item'>
                    
                                                        ${data.amount}</span>
                                                    </td>
                                                    <td
                                                      data-label='DUE DATE'
                                                      className='due_date hover_payment position-relative'>
                                                      <span
                                                        className='hover_item'
                                                      >
                                                        {data.dueDate}
                    
   {showDueDateBox === i && (
                                                          <div
                                                            className='due_date_box'
                                                          >
                                                            <div className='due_date_box_header d-flex align-items-center justify-content-between'>
                                                              <h4>Set Payment Due</h4>
                                                              <span >
                                                                <i className='fas fa-close'></i>
                                                              </span>
                                                            </div>
                                                            <div className='arrow'></div>
                    
                                                            <div className='due_date_box_content mt-2'>
                                                              {smartdate && (
                                                                <CommonDropdownMenuThree options={options} suboption={options_sub} rawselectedOption={options[1]} />
                                                              )
                                                              }
                    
                                                              {!smartdate && (
                                                                <CommonDropdownMenuThree options={options} suboption={options_sub} rawselectedOption={options[0]} />
                                                              )
                                                              }
                    
                                                              {
                                                                smartdate && (
                                                                  <div className="d-flex smartdate">
                                                                    <input className="smardatinp" value={smartday} onChange={(e) => setsmartday(e.target.value)} />&nbsp;
                                                                    <CommonDropdownMenufour options={options2} />&nbsp;
                                                                    <CommonDropdownMenufour options={options3} />
                                                                  </div>
                                                                )
                    
                                                              }
                    
                    
                                                              {!smartdate && (
                                                                <div className='mt-3 date_input'>
                                                                  <input
                                                                    type='date'
                    
                    
                                                                  />
                                                                </div>
                                                              )
                    
                                                              }
                    
                    
                    
                                                              <div className='mt-3 text-end'>
                                                                <button >
                                                                  Save
                                                                </button>
                                                              </div>
                                                            </div>
                    
                                                            <div className='arrow'></div>
                                                          </div>
                                                        )}
                                                      </span>
                                                    </td>
                                                    <td data-label='PAYMENT DATE'>{data.paid_at === "-"
                                            ? data.paid_at
                                            : new Date(data.paid_at).toLocaleDateString("en-US", {
                                                timeZone: "UTC",
                                              })}</td>
                                                    <td data-label='PAYMENT ID'>{invoicecode}</td>
                                                    <td
                                                      data-label='STATUS'
                                                      className='text-end position-relative'
                                                      style={{ cursor: "pointer" }}>
                                                      {data.status}
                                                    </td>
                                                  </tr>
                                                ))}
                                              </tbody>
                                            </table>
                                          </div>
                                          {/* add new payment button  */}
                    
                                        </section>
                      
                      
                      </>)}






                    




                </>


              ))}
             
            </div>
           
           
           
          </div>
        </div>
      </div>



    {/* start of the sign popup */}
      <div
        class='offcanvas offcanvas-end'
        tabindex='-1'
        id='signpopup'
        aria-labelledby='offcanvasRightLabel'
        data-bs-backdrop='false'>
        <div class='w-100 text-start header'>
          <button
            type='button'
            class='btn-close mt-3 ms-4 text-black'
            data-bs-dismiss='offcanvas'
            aria-label='Close'></button>


          <div className='text-center py-3'>
            <h5>Signature</h5>
            <span style={{ color: "#727272" }}>
              Add Your Signature
            </span>
          </div>
        </div>


        <div class='offcanvas-body p-0'>

          <div className='single_box mt-3'>
            <div className='d-flex align-items-center justify-content-between'>
              <div >
                <input type="text" className="signbox" onChange={handleChange} value={signaturebox} />
              </div>
            </div>
          </div>

          <div className='single_box mt-3'>
            <div className='d-flex align-items-center justify-content-between'>
              <div >
                <input type="checkbox" onChange={handleCheckboxChange} />By Clicking, I, <b> {username}  </b> hereby consent to the use of my electronic signature for the execution of this document. I acknowledge and agree that my electronic signature shall have the same validity, enforceability, and legal effect as my handwritten signature.
              </div>
            </div>
          </div>

          <div className='single_box mt-3'>
            <div className='d-flex align-items-center justify-content-between'>
              <div >
                <button
                  type='button'
                  class='mt-3 ms-4 text-black backbackground add_Signature'
                  data-bs-dismiss='offcanvas'
                  disabled={!isChecked}
                  onClick={addsignature}
                  aria-label='Close'>SIGN</button>
              </div>
            </div>
          </div>

        </div>







      </div>



      {/* end of the sign popup */}





    </div>
  );
}

export default ViewProposalInfoModal;
